export type PostAccessType = 'PaidMembers' | 'FreeMembers' | 'FreeAndPaidMembers' | 'Tiers'

export enum FormFields {
  image = 'image',
  text = 'text',
  access = 'access',
  tierIds = 'tierIds',
}

export type FormValues = {
  [FormFields.image]: string
  [FormFields.text]: string
  [FormFields.access]: PostAccessType
  [FormFields.tierIds]: string[]
}
